import React from 'react';

const translations = {};
const settings = {};

export const TranslationContext = React.createContext(translations);
export const SettingsContext = React.createContext(settings);